
(function () {
  if (window.customElements.get("sticky-add-to-cart")) {
    return;
  }

  const MOBILE_MEDIA_QUERY = "(max-width: 699px)";

  function getStickyAreaHeightPx() {
    const probe = document.createElement("div");
    probe.style.cssText =
      "position:absolute;visibility:hidden;pointer-events:none;height:0;width:0;top:var(--sticky-area-height, 0px);";
    document.body.appendChild(probe);
    const height = parseFloat(getComputedStyle(probe).top) || 0;
    probe.remove();
    return Math.max(height, 0);
  }

  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this._mediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY);
      this._observer = null;
      this._referenceElements = [];
      this._scrolledPastByElement = new Map();
      this._onIntersect = this._onIntersect.bind(this);
      this._onMediaChange = this._onMediaChange.bind(this);
    }

    connectedCallback() {
      const formName = this.getAttribute("observe");
      const form = formName ? document.forms[formName] : null;

      if (!form) {
        return;
      }

      this._referenceElements = [form];

      const defaultKlarna = document.querySelector('.product-info [data-block-id*="klarna"]');
      if (defaultKlarna) {
        this._referenceElements.push(defaultKlarna);
      }

      this._mediaQueryList.addEventListener("change", this._onMediaChange);
      this._syncObserver();
    }

    disconnectedCallback() {
      this._mediaQueryList.removeEventListener("change", this._onMediaChange);
      this._teardownObserver();
    }

    _onMediaChange() {
      this._syncObserver();
    }

    _syncObserver() {
      if (this._mediaQueryList.matches) {
        if (!this._observer) {
          const rootMarginTop = getStickyAreaHeightPx();
          this._observer = new IntersectionObserver(this._onIntersect, {
            threshold: 0,
            rootMargin: `-${rootMarginTop}px 0px 0px 0px`,
          });
          this._referenceElements.forEach((element) => this._observer.observe(element));
        }
      } else {
        // Desktop: never show, and stop observing entirely so no work happens off-viewport.
        this._teardownObserver();
        this.classList.remove("is-visible");
      }
    }

    _teardownObserver() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      this._scrolledPastByElement.clear();
    }

    _onIntersect(entries) {
      entries.forEach((entry) => {
        const visibleTop = entry.rootBounds ? entry.rootBounds.top : 0;
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < visibleTop;
        this._scrolledPastByElement.set(entry.target, scrolledPast);
      });

      const allScrolledPast = this._referenceElements.every(
        (element) => this._scrolledPastByElement.get(element) === true
      );
      this.classList.toggle("is-visible", allScrolledPast);
    }
  }

  window.customElements.define("sticky-add-to-cart", StickyAddToCart);
})();
